import { useCallback } from 'react'

import { useConfigurationContext } from '../../context/configurationContext'
import { useSpecId } from '../../system/useSpecId'
import {
  getReconciliationSpecOperationAtDate,
  getReconciliationSpecOperationFromDate,
} from '../../uiModels/reconciliationSpecOperations/helpers'
import type { IndexedReconciliationSpecOperationWithMetaData } from '../../uiModels/reconciliationSpecOperations/types'
import { useApplicationViewOperationsContext } from '../../workspace/applicationViewOperationsContext'

/**
 * Tells whether a reconciliation-spec version is the one in effect at the current view
 * date, ie. the version the viewer is currently showing.
 */
export const useIsReconciliationSpecVersionActive = () => {
  const { viewAt } = useConfigurationContext()
  const specId = useSpecId()
  const { applicationReconciliationSpecs } =
    useApplicationViewOperationsContext()
  const activeOperation = getReconciliationSpecOperationAtDate(
    applicationReconciliationSpecs.get(specId),
    viewAt,
  )?.internalOperation

  return useCallback(
    (version: IndexedReconciliationSpecOperationWithMetaData) =>
      !!activeOperation &&
      getReconciliationSpecOperationFromDate(version.internalOperation) ===
        getReconciliationSpecOperationFromDate(activeOperation) &&
      // Every version on the timeline belongs to the spec in scope, so this only guards
      // against a future timeline mixing specs.
      version.internalOperation.reconciliationSpec?.specId ===
        activeOperation.reconciliationSpec?.specId,
    [activeOperation],
  )
}
